import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
    LayoutDashboard, Server, Users, GitBranch, Terminal, Settings, LogOut, Shield,
} from "lucide-react";
import { useAuth } from "@/lib/auth";

const NAV = [
    { to: "/", label: "Обзор", icon: LayoutDashboard, exact: true },
    { to: "/servers", label: "Серверы", icon: Server },
    { to: "/users", label: "Пользователи", icon: Users },
    { to: "/chains", label: "Маршруты", icon: GitBranch },
    { to: "/deployments", label: "Журнал деплоев", icon: Terminal },
    { to: "/settings", label: "Настройки", icon: Settings },
];

export default function Layout() {
    const { admin, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex bg-[#F4F4F5]">
            {/* Sidebar */}
            <aside className="w-64 shrink-0 bg-zinc-50 border-r border-zinc-200 flex flex-col" data-testid="app-sidebar">
                <div className="h-16 flex items-center gap-2.5 px-5 border-b border-zinc-200">
                    <div className="w-8 h-8 bg-[#FA3E05] rounded-md flex items-center justify-center">
                        <Shield className="w-4 h-4 text-white" strokeWidth={2.25} />
                    </div>
                    <div className="leading-tight">
                        <div className="text-sm font-semibold tracking-tight">Youstylist</div>
                        <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">admin</div>
                    </div>
                </div>

                <nav className="flex-1 p-3 space-y-0.5">
                    {NAV.map(({ to, label, icon: Icon, exact }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={exact}
                            data-testid={`nav-${to.replace("/", "") || "dashboard"}`}
                            className={({ isActive }) =>
                                `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${
                                    isActive
                                        ? "bg-white border border-zinc-200 text-[#FA3E05] font-medium shadow-sm"
                                        : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 border border-transparent"
                                }`
                            }
                        >
                            <Icon className="w-4 h-4" strokeWidth={1.75} />
                            {label}
                        </NavLink>
                    ))}
                </nav>

                <div className="p-3 border-t border-zinc-200">
                    <div className="px-2.5 py-2 text-xs text-zinc-500">
                        <div className="truncate font-mono" title={admin?.email}>{admin?.email}</div>
                        <div className="uppercase tracking-widest text-[10px] mt-0.5">{admin?.role}</div>
                    </div>
                    <button
                        data-testid="logout-btn"
                        onClick={async () => { await logout(); navigate("/login"); }}
                        className="w-full mt-1 flex items-center gap-2 px-3 py-2 text-sm text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 rounded-md transition-colors"
                    >
                        <LogOut className="w-4 h-4" strokeWidth={1.75} />
                        Выйти
                    </button>
                </div>
            </aside>

            {/* Main */}
            <main className="flex-1 min-w-0">
                <Outlet />
            </main>
        </div>
    );
}
